import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './style/sidenav.module.css';
import { NavLink, useLocation } from 'react-router-dom';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import { useContext, useState } from 'react';
import HomeIcon from '@mui/icons-material/Home';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import ManageFirm from '@mui/icons-material/Groups';
import PaymentIcon from '@mui/icons-material/Payment';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import UserContext from './UserContext';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import HelpIcon from '@mui/icons-material/Help';
import MailIcon from '@mui/icons-material/Mail';
import XpmIcon from '@mui/icons-material/Power';
import AppConfig from './AppConfig';
import BasReadyLogo from './images/logo_white_long_style_app_store_version.svg';
import { Box, Tooltip } from '@mui/material';
import { hasFeature, isBillingAdmin } from './business/Subscription';
function getNavData(user) {
    var _a, _b;
    var index = 0;
    // @ts-ignore
    return [
        ((_a = user === null || user === void 0 ? void 0 : user.firm) === null || _a === void 0 ? void 0 : _a.subscription) && {
            id: index++,
            icon: (_jsx(HomeIcon, {})),
            text: 'Dashboard',
            link: 'dashboard',
        },
        user &&
            ((_b = user === null || user === void 0 ? void 0 : user.firm) === null || _b === void 0 ? void 0 : _b.subscription) && {
            id: index++,
            icon: (_jsx(TravelExploreIcon, {})),
            text: 'Organisations',
            link: 'organisations',
        },
        user && {
            id: index++,
            icon: (_jsx(PaymentIcon, {})),
            text: 'Subscription',
            link: 'subscription',
        },
        user &&
            hasFeature(user, 'Emails') && {
            id: index++,
            icon: (_jsx(MailIcon, {})),
            text: 'Emails',
            link: 'emails',
        },
        user &&
            hasFeature(user, 'XPM') && {
            id: index++,
            icon: (_jsx(XpmIcon, {})),
            text: 'XPM',
            alt: 'Xero Practice Manager',
            link: 'xpm',
        },
        user && {
            id: index++,
            icon: (_jsx(ManageAccountsIcon, {})),
            text: 'User Settings',
            link: 'user-settings',
        },
        user &&
            isBillingAdmin(user) &&
            hasFeature(user, 'MultiUser') && {
            id: index++,
            icon: (_jsx(ManageFirm, {})),
            text: 'Manage Firm',
            link: 'firm',
        },
        user &&
            (user === null || user === void 0 ? void 0 : user.isAdmin) && {
            id: index++,
            icon: (_jsx(AdminPanelSettingsIcon, {})),
            text: 'Manage',
            link: 'manage',
        },
        user == null
            ? {
                id: index++,
                icon: (_jsx(LoginIcon, {})),
                text: 'Login',
                externalLink: `${AppConfig.oauthLoginPath}`,
            }
            : {
                id: index++,
                icon: (_jsx(LogoutIcon, {})),
                text: 'Logout',
                externalLink: `${AppConfig.logoutPath}`,
                spacerBefore: true,
            },
    ].filter(Boolean);
}
function getBottomNavData() {
    return [
        {
            id: 8,
            icon: (_jsx(HelpIcon, {})),
            text: 'Support/Help',
            link: 'support',
        },
    ];
}
export default function SideNav() {
    const [open, setOpen] = useState(true);
    const location = useLocation();
    const userContext = useContext(UserContext);
    const user = userContext === null || userContext === void 0 ? void 0 : userContext.user;
    const toggleOpen = () => {
        setOpen(!open);
    };
    return (_jsx("div", { className: open ? styles.sidenav : styles.sidenavClosed, children: _jsxs(Box, { display: "flex", flexDirection: "column", height: "100%", children: [_jsxs("div", { children: [_jsx("div", { style: { paddingBottom: '20px' }, children: _jsx("img", { src: BasReadyLogo, style: { width: '130px' } }) }), user && (_jsx("button", { className: styles.menuBtn, onClick: toggleOpen, children: open ? _jsx(KeyboardDoubleArrowLeftIcon, {}) : _jsx(KeyboardDoubleArrowRightIcon, {}) })), getNavData(user).map(item => {
                            return (_jsxs("div", { children: [item.spacerBefore && _jsx("div", { style: { height: '30px' } }), item.link && (_jsxs(NavLink, { className: location.pathname === `/${item.link}` ? styles.sideItemSelected : styles.sideItem, to: item.link, children: [item.icon, _jsx(Tooltip, { title: item.alt, children: _jsx("span", { className: styles.linkText, children: item.text }) })] }, item.id)), item.externalLink && (_jsxs("a", { className: styles.sideItem, href: item.externalLink, children: [item.icon, _jsx(Tooltip, { title: item.alt, children: _jsx("span", { className: styles.linkText, children: item.text }) })] }))] }, item.id));
                        })] }), _jsx("div", { style: { marginTop: 'auto' }, children: getBottomNavData().map(item => {
                        return (_jsxs("div", { children: [item.spacerBefore && _jsx("div", { style: { height: '30px' } }), item.link && (_jsxs(NavLink, { className: location.pathname === `/${item.link}` ? styles.sideItemSelected : styles.sideItem, to: item.link, children: [item.icon, _jsx("span", { className: styles.linkText, children: item.text })] }, item.id)), item.externalLink && (_jsxs("a", { className: styles.sideItem, href: item.externalLink, children: [item.icon, _jsx("span", { className: styles.linkText, children: item.text })] }))] }, item.id));
                    }) })] }) }));
}
